import * as actionTypes from '../constants/actionTypes';
import { updateObject } from '../../utils';

const initialState = {
  remainderNotificationMessage: null,
  unreadMessage: null,
  smsMessage: null,
  bufferOfMessageToSend: [],
};

const setRemainderNotificationMessage = (state, action) => {
  return updateObject(state, {
    remainderNotificationMessage: action.data,
  });
};

const setUnreadMessage = (state, action) => {
  return updateObject(state, {
    unreadMessage: action.data,
  });
};

const setSmsMessage = (state, action) => {
  return updateObject(state, {
    smsMessage: action.data,
  });
};

const sendMessage = (state, action) => {
  let newBufferOfMessageToSend = [...state.bufferOfMessageToSend];
  newBufferOfMessageToSend.push(action.data);

  return updateObject(state, {
    bufferOfMessageToSend: newBufferOfMessageToSend,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.WEB_SOCKET_SET_REMAINDER_NOTIFICATION_MESSAGE:
      return setRemainderNotificationMessage(state, action);

    case actionTypes.WEB_SOCKET_SET_UNREAD_MESSAGE:
      return setUnreadMessage(state, action);

    case actionTypes.WEB_SOCKET_SET_SMS_MESSAGE:
      return setSmsMessage(state, action);

    case actionTypes.WEB_SOCKET_SEND_MESSAGE:
      return sendMessage(state, action);

    default:
      return state;
  }
};

export default reducer;
